import axios from 'axios';
import { SharedData } from './../shared-data';
import { AppEndPoints } from 'src/config/end-points.constants';


const API_URL = AppEndPoints.NSE_HISTORICAL_DATA;
// const API_URL = 'https://tradewatch.cryptocentric.io/api/v1.0/trading/getYahooChart';
// const API_URL = 'https://query1.finance.yahoo.com/v8/finance/chart/';
let URL = ' ';
// https://query1.finance.yahoo.com/v8/finance/chart/TCS.BO?interval=1d&period1=1711788968&period2=1742893029
// https://query1.finance.yahoo.com/v8/finance/chart/^NSEI?interval=1d&period1=1711944051&period2=1743048111
const intervalMap: { [key: string]: string } = {
  '1': '1m',
  '5': '5m',
  '15': '15m',
  '30': '30m',
  '60': '1h',
  '120': '1h',
  '180': '2h',
  D: '1d',
};

async function getHistory(
  symbol: string,
  interval: string,
  from: number,
  to: number
) {
  try {
    let value$ = SharedData.data$;
    let response: any;
    value$.subscribe((ele) => {
      URL = `${API_URL}?symbol=${symbol}&exchType=${ele}&fromDate=${from}&endDate=${to}&interval=${interval}`
      SharedData.updateSymbol(symbol);
    });
    response = await axios.get(`${URL}`);

    const result = response.data.chart.result[0];
    if (!result) throw new Error('No data available');

    const bars = result.timestamp.map((timestamp: number, index: number) => ({
      time: timestamp * 1000,
      open: result.indicators.quote[0].open[index],
      high: result.indicators.quote[0].high[index],
      low: result.indicators.quote[0].low[index],
      close: result.indicators.quote[0].close[index],
      volume: result.indicators.quote[0].volume[index],
    }));

    return bars;
  } catch (error) {
    console.error('Error fetching historical data:', error);
    throw error;
  }
}

export default {
  async getBars(
    symbolInfo: any,
    resolution: string,
    from: number,
    to: number,
    first: any,
    limit: any
  ): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      const interval = intervalMap[resolution] || '1d';
      try {
        const bars = await getHistory(symbolInfo.name, interval, from, to);
        resolve(bars);
      } catch (error) {
        reject(error);
      }
    });
  },
};
